const everyone = () => true

export default [
  {
    text: 'Dashboard',
    to: '/dashboard',
    for: everyone,
    icon: 'bx bx-grid-alt'
  },
  { divider: true },
  {
    text: 'Invitations',
    to: '/invitations',
    for: everyone,
    icon: 'bx bxs-envelope'
  },
  { divider: true },
  { header: true, text: 'Documents' },
  {
    text: 'New Document',
    to: '/document/new',
    for: everyone,
    icon: 'bx bx-edit'
  },
  {
    text: 'Register',
    to: '/register',
    for: everyone,
    icon: 'bx bx-cabinet'
  },
  {
    text: 'Share Register',
    to: '/share-register',
    for: ({ isStandardBusiness, featureEnabled }) =>
      isStandardBusiness && featureEnabled('shareRegister'),
    icon: 'bx bx-cabinet'
  },
  { divider: true },
  {
    group: 'admin',
    text: 'Admin',
    children: [
      {
        text: 'Clients',
        to: '/clients',
        for: ({ isAdmin, isAdviser }) => isAdviser || isAdmin,
        icon: 'bx bx-user'
      },
      {
        text: 'Users',
        to: '/users',
        for: ({ isAdmin, isAccountAdmin }) => isAccountAdmin || isAdmin,
        icon: 'bx bx-user'
      },
      {
        text: 'Templates',
        to: '/oladmin/templates',
        for: ({ isAdmin }) => isAdmin,
        icon: 'bx bx-receipt'
      },
      { divider: true }
    ]
  },
  {
    group: 'admin',
    text: 'Account Admin',
    children: [
      {
        text: 'Users',
        to: '/users',
        for: ({ isAdmin, isAccountAdmin }) => isAccountAdmin && !isAdmin,
        icon: 'bx bx-user'
      },
      {
        text: 'Clients',
        to: '/clients',
        for: ({ isStandardBusiness, isAdmin }) =>
          isStandardBusiness && !isAdmin,
        icon: 'bx bxs-user-account'
      },
      { divider: true }
    ]
  },
  { divider: true },
  {
    text: 'Account Status',
    to: '/account-status',
    for: ({ featureEnabled, isAccountOwner }) =>
      featureEnabled('accountStatus') && isAccountOwner,
    icon: 'bx bxs-user-detail'
  },
  {
    text: 'Manage MFA',
    to: '/manage-mfa',
    for: ({ featureEnabled }) => featureEnabled('mfa'),
    icon: 'bx bxs-lock'
  }
]
